import { createReducer } from '@reduxjs/toolkit'

import { loggedInClubOne, loggedOutClubOne, receivedCoupons, requestCoupons } from '../actions/actions'

export const initialState = {
  loading: false,
  coupons: [],
  requested: false
}

const coupons = createReducer(initialState, {
  [requestCoupons]: state => {
    state.loading = true
    state.requested = true
  },
  [receivedCoupons]: (state, { payload: { coupons } }) => {
    state.loading = false
    state.coupons = coupons
  },
  [loggedInClubOne]: (state, { payload: { clearCoupons } }) => {
    if (clearCoupons) state.coupons = []
  },
  [loggedOutClubOne]: (state, { payload: { clearCoupons } }) => {
    if (clearCoupons) state.coupons = []
  }
})

export default coupons
